import styled, { css } from 'vue3-styled-components';

// 기본 레이아웃
export const ManagePageContainer = styled.div`
    padding: 0 24px;
    margin-left: 260px;
    min-height: 100vh;
    background: #f8fafc;
    border-radius: 10px;
`;

export const MainContentWrapper = styled.div`
    max-width: 1400px;
    margin: 0 auto;
    padding: 24px 0;
`;

// 헤더 섹션
export const HeaderSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 32px;
    background: white;
    padding: 24px 32px;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const HeaderTitle = styled.div`
    h1 {
        font-size: 28px;
        font-weight: 700;
        color: #1e293b;
        margin: 0 0 8px 0;
    }
    
    span {
        color: #64748b;
        font-size: 16px;
        font-weight: 400;
    }
`;

export const HeaderActions = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const ActionButton = styled.button`
    padding: 8px 16px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
    
    &:active {
        transform: translateY(0);
    }
`;

export const PrimaryButton = styled(ActionButton)`
    background: #0f4c5c;
    color: white;
    
    &:hover {
        background: #0a3a47;
    }
`;

// 검색 및 갱신 정보 섹션
export const SearchAndUpdateSection = styled.div`
    display: flex;
    gap: 24px;
    margin-bottom: 32px;
    
    @media (max-width: 1200px) {
        flex-direction: column;
        gap: 16px;
    }
`;

export const SearchCard = styled.div`
    flex: 2;
    background: white;
    padding: 24px 32px;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    min-width: 0;
`;

export const SearchRow = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;
    margin-bottom: 16px;
    
    &:last-child {
        margin-bottom: 0;
    }
`;

export const SearchGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    
    label {
        font-weight: 600;
        color: #374151;
        min-width: 80px;
    }
`;

export const SearchField = styled.div`
    select {
        padding: 10px 16px;
        border: 2px solid #e5e7eb;
        border-radius: 10px;
        background: white;
        color: #374151;
        font-weight: 500;
        transition: all 0.2s ease;
        min-width: 150px;
        
        &:focus {
            outline: none;
            border-color: #0f4c5c;
            box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
        }
    }
`;

export const SearchInput = styled.input`
    padding: 12px 16px;
    border: 2px solid #e5e7eb;
    border-radius: 10px;
    font-size: 14px;
    transition: all 0.2s ease;
    flex: 1;
    max-width: 300px;
    
    &:focus {
        outline: none;
        border-color: #0f4c5c;
        box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
    }
    
    &::placeholder {
        color: #9ca3af;
    }
`;

export const SearchButton = styled.button`
    padding: 10px 16px;
    background: #0f4c5c;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
        transform: translateY(-1px);
        background: #0f5c6c;
    }
`;

// 필터 관련
export const FilterGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    
    label {
        font-weight: 600;
        color: #374151;
        min-width: 80px;
    }
`;

export const FilterChips = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
`;

const chipProps = css`
    ${props => props.active && css`
        background: #0f4c5c;
        color: white;
        border-color: #0f4c5c;
    `}
`;

export const ManageButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    padding: 8px 16px;
    background: linear-gradient(135deg, #2563eb 0%, #3b82f6 100%);
    color: white;
    border: none;
    border-radius: 20px;
    font-size: 14px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    
    &:hover {
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        transform: translateY(-2px);
        
        &::before {
            left: 100%;
        }
    }
`;

export const FilterChip = styled.div`
    padding: 8px 16px;
    border: 2px solid #e5e7eb;
    border-radius: 20px;
    background: white;
    color: #374151;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    ${chipProps}
    
    &:hover {
        border-color: #0f4c5c;
    }
`;

export const ActiveFilterChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`;

export const ActiveFilterChip = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  background: #ff6b6b;
  color: white;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  
  &:hover {
    background: #ff5252;
    transform: translateY(-1px);
  }
`;

export const ClearAllFiltersButton = styled.button`
  padding: 6px 16px;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: #5a6268;
    transform: translateY(-1px);
  }
`;

// 통계 섹션
export const StatsSection = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;
    margin-bottom: 32px;
`;

export const StatsCard = styled.div`
    background: white;
    padding: 24px;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    text-align: center;
    transition: all 0.2s ease;
    
    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
    }
`;

export const StatsNumber = styled.div`
    font-size: 32px;
    font-weight: 700;
    color: #cc5803;
    margin-bottom: 8px;
`;

export const StatsLabel = styled.div`
    font-size: 16px;
    color: #64748b;
    font-weight: 500;
`;

// 갱신 정보 섹션
export const UpdateInfoSection = styled.div`
    margin-bottom: 32px;
`;

export const UpdateInfoCard = styled.div`
    flex: 1;
    background: white;
    padding: 24px 32px;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    min-width: 300px;
`;

export const UpdateInfoTitle = styled.h3`
    font-size: 18px;
    font-weight: 600;
    color: #1e293b;
    margin: 0 0 20px 0;
    text-align: center;
`;

export const UpdateInfoContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const UpdateInfoRow = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 12px;
`;

export const UpdateInfoItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
`;

export const UpdateInfoLabel = styled.span`
    font-weight: 600;
    color: #374151;
    font-size: 16px;
`;

export const UpdateInfoValue = styled.span`
    color: #64748b;
    font-weight: 500;
    font-size: 15px;
    padding: 8px 12px;
    background: #f8fafc;
    border-radius: 8px;
    text-align: center;
`;

export const UpdateTypeSelect = styled.select`
    padding: 10px 16px;
    border: 2px solid #e5e7eb;
    border-radius: 10px;
    background: white;
    color: #374151;
    font-weight: 500;
    font-size: 15px;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:focus {
        outline: none;
        border-color: #0f4c5c;
        box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
    }
`;

export const UpdateActionButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: #0f4c5c;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 10px;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    
    &:hover {
        transform: translateY(-2px);
    }
    
    &:active {
        transform: translateY(0);
    }
`;

// 테이블 섹션
export const TableSection = styled.div`
    background: white;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    overflow: hidden;
`;

export const TableHeader = styled.div`
    display: flex;
    align-items: center;
    padding: 24px 32px;
    border-bottom: 1px solid #e5e7eb;
    flex-wrap: wrap;
    gap: 16px;
`;

export const SubTitle = styled.h2`
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
    margin-right: 15px;
`;

// 테이블
export const TableContainer = styled.div`
    overflow-x: auto;
`;

export const ModernTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    
    th, td {
        padding: 14px;
        text-align: center;
        border-bottom: 1px solid #f1f5f9;
    }
    
    th {
        background: #f8fafc;
        font-weight: 600;
        color: #374151;
        font-size: 14px;
        white-space: nowrap;
    }
    
    td {
        color: #1e293b;
        font-size: 14px;
    }
    
    tbody tr {
        cursor: pointer;
        
        &:hover {
            background: #f8fafc;
        }
    }
`;

// 즐겨찾기 버튼
export const FavoriteButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    border-radius: 6px;
    transition: all 0.2s ease;
    
    &:hover {
        background: #ffeccc;
        transform: scale(1.1);
    }
`;

const favoriteIconProps = css`
    ${props => props.favorite && css`
        color: #fbbf24;
    `}
`;

export const FavoriteIcon = styled.span`
    font-size: 25px;
    color: #d1d5db;
    transition: all 0.2s ease;
    ${favoriteIconProps}
`;

// 거래처 정보
export const CompanyInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const CompanyName = styled.div`
    font-weight: 500;
    font-size: 14px;
`;

export const CompanyId = styled.div`
    font-size: 14px;
`;

export const CompanyAddress = styled.div`
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const CompanyPhone = styled.div`
    font-size: 14px;
`;

export const CompanyEmail = styled.div`
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

// 페이지네이션
export const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 32px;
    border-top: 1px solid #e5e7eb;
`;

export const Pagination = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const PaginationButton = styled.button`
    padding: 4px 6px;
    border: 2px solid #e5e7eb;
    background: white;
    color: #374151;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s ease;
    
    &:hover:not(:disabled) {
        border-color: #fb8b24;
        color: #fb8b24;
    }
    
    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

const paginationNumberProps = css`
    ${props => props.active && css`
        background: #fb8b24;
        color: white;
        border-color: #fb8b24;
    `}
`;

export const PaginationNumber = styled.button`
    min-width: 36px;
    height: 36px;
    padding: 0 8px;
    border: 2px solid #e5e7eb;
    background: white;
    color: #374151;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s ease;
    white-space: nowrap;
    ${paginationNumberProps}
    
    &:hover:not(:disabled) {
        border-color: #fb8b24;
        color: #fb8b24;
    }
`;

export const ItemsPerPageSelector = styled.div`
    select {
        padding: 8px 12px;
        border: 2px solid #e5e7eb;
        border-radius: 8px;
        background: white;
        color: #374151;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s ease;
        margin-right: 15px;
        
        &:focus {
            outline: none;
            border-color: #0f4c5c;
            box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
        }
    }
`;